import { IconPhone } from './sidebarIcons';
import Sidebar from '../components/SidebarNext';

const NAV = [
    { to: '/platform/availability', label: 'Availability', icon: <IconPhone />, end: true },
];

export default function PlatformLayout({ user, onLogout, children }) {
    return (
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: '#FAF8FC' }}>
            <Sidebar navItems={NAV} sectionLabel="Platform" homeHref="/landing" user={user} domainKey="platform" />
            <div id="sbn-main" className="sbn-content"
                 style={{ flex: 1, minWidth: 0, padding: '28px 32px', overflowY: 'auto', height: '100%' }}>
                {children}
            </div>
        </div>
    );
}